import type { ConversionVendor } from '../useConversionTracker';

type VendorEventMap = Partial<Record<ConversionVendor, string>>;
type ConversionEventMap = Record<string, VendorEventMap>;

const conversionEventMap: ConversionEventMap = {
  store_launched: {
    google: 'D_LsCPfqrsEcEPin4v4D',
    facebook: 'Store Built',
  },
  logo_applied: {
    google: 'bHfxCPmQm8EcEPin4v4D',
    facebook: 'DIY Logos Added',
  },
  product_added: {
    google: 'vXr-CPeQgcEcEPin4v4D',
    facebook: 'DIY Items Added',
  },
  fundraising_added: {
    google: 'KSATCMT5rsEcEPin4v4D',
    facebook: 'DIY Fundraising Added',
  },
  submit_signup: {
    google: '4RkkCPXm8rMcEPin4v4D',
    facebook: 'DIY Submit Signup Form',
  },
};

export function resolveVendorEventName(event: string, vendor: ConversionVendor): string | undefined {
  return conversionEventMap[event]?.[vendor];
}
